import {DatePicker, Form} from "antd";

export function DataFromField(){

    return <>
        <Form.Item name={"dataFrom"}>
            <DatePicker placeholder="Data da" format="DD/MM/YYYY" />
        </Form.Item>
    </>
}